// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.mjs";

function decodeInvalidCredentials(_json) {
  return /* DefaultError */{
          _0: {
            title: /* Unauthorized */1,
            message: "Unauthorized action"
          }
        };
}

function execute(response) {
  if (typeof response === "number" || response.TAG !== /* Unauthorized */4) {
    return ResponseHandler$Catalyst.DefaultErrorConverter.execute(response);
  } else {
    return /* DefaultError */{
            _0: {
              title: /* Unauthorized */1,
              message: "Unauthorized action"
            }
          };
  }
}

export {
  decodeInvalidCredentials ,
  execute ,
}
/* ResponseHandler-Catalyst Not a pure module */
